import React from "react";
import { FaRegSmile, FaRegThumbsUp, FaRegHandshake, FaStar } from "react-icons/fa";

const testimonials = [
  {
    name: "Pooja",
    text: "Urban Nest made my plot buying seamless and transparent. Highly recommend them for their genuine approach.",
    icon: <FaRegSmile className="text-violet-600 text-4xl mb-4" />,
  },
  {
    name: "Neha",
    text: "The team was very supportive and provided clear information about approvals. Very happy with my investment.",
    icon: <FaRegThumbsUp className="text-violet-600 text-4xl mb-4" />,
  },
  {
    name: "Pradeep",
    text: "I found a prime BMRDA plot near Nelamangala with the help of Urban Nest. Smooth process from start to finish.",
    icon: <FaRegHandshake className="text-violet-600 text-4xl mb-4" />,
  },
  {
    name: "Kartik",
    text: "The site visit and explanation were detailed. The appreciation potential is great. Thank you Urban Nest!",
    icon: <FaStar className="text-violet-600 text-4xl mb-4" />,
  },
];

export default function Testimonials() {
  return (
    <section className="mt-5 md:py-12 bg-gradient-to-r from-violet-50 to-violet-100"style={{fontFamily:'poppins'}}>
      <div className="max-w-7xl mx-auto px-4">
        <h3 className="text-3xl md:text-4xl font-bold text-center text-[#1B0727] mb-5 md:mb-10">
          What Our Clients Say
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow hover:shadow-lg transform hover:-translate-y-2 transition cursor-pointer text-center flex flex-col items-center"
            >
              {testimonial.icon}
              <p className="text-gray-700 italic mb-4">"{testimonial.text}"</p>
              <h3 className="text-lg font-semibold text-[#1B0727]">
                - {testimonial.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
